import { Globe2, Info, Lock, Users } from 'lucide-react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import type { PromptVisibility } from './promptsV2Types';
import { promptVisibilityMeta, visibilityTooltipForItem } from '../../utils/promptVisibilityMeta';
import './PromptVisibilityIndicator.css';

type PromptVisibilityIndicatorProps = {
  visibility?: PromptVisibility | string | null;
  itemLabel?: string;
  compact?: boolean;
};

function VisibilityIcon({ tone }: { tone: 'public' | 'recruiters' | 'private' }) {
  if (tone === 'private') return <Lock size={14} aria-hidden />;
  if (tone === 'recruiters') return <Users size={14} aria-hidden />;
  return <Globe2 size={14} aria-hidden />;
}

export function PromptVisibilityIndicator({
  visibility,
  itemLabel = 'prompt',
  compact = false,
}: PromptVisibilityIndicatorProps) {
  const meta = promptVisibilityMeta(visibility);
  const tooltip = visibilityTooltipForItem(visibility, itemLabel);

  return (
    <div
      className={`prompt-visibility-indicator prompt-visibility-indicator--${meta.tone}${
        compact ? ' prompt-visibility-indicator--compact' : ''
      }`}
    >
      <span className="prompt-visibility-indicator__badge">
        <span className="prompt-visibility-indicator__icon" aria-hidden>
          <VisibilityIcon tone={meta.tone} />
        </span>
        <span className="prompt-visibility-indicator__label">{meta.label}</span>
      </span>
      <OverlayTrigger
        placement="top"
        trigger={['hover', 'focus']}
        overlay={
          <Tooltip id={`prompt-visibility-tip-${meta.tone}`} className="prompt-visibility-tooltip">
            {tooltip}
          </Tooltip>
        }
      >
        <button
          type="button"
          className="prompt-visibility-indicator__info"
          aria-label={`About ${meta.label} privacy`}
          onClick={(event) => event.stopPropagation()}
        >
          <Info size={14} aria-hidden />
        </button>
      </OverlayTrigger>
    </div>
  );
}
